import { render, staticRenderFns } from "./AgencyBalance.vue?vue&type=template&id=681f6b74&scoped=true&"
import script from "./AgencyBalance.vue?vue&type=script&lang=js&"
export * from "./AgencyBalance.vue?vue&type=script&lang=js&"
import style0 from "./AgencyBalance.vue?vue&type=style&index=0&id=681f6b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f6b74",
  null
  
)

export default component.exports